import { useState } from "react";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { WorkingHoursGuideModal } from "./WorkingHoursGuideModal";

/**
 * Редът над седмицата: едно изречение за какво служи работното време и линк
 * „Как работи?", който отваря модала с примерите за справките и резервациите
 * (`WorkingHoursGuideModal`).
 */
export function WorkingHoursGuide() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <p className="m-0 text-[13px] leading-[1.5] text-muted">
        {t("workingHours.guide.text")}{" "}
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="inline-flex cursor-pointer items-center gap-1 border-none bg-transparent p-0 text-[13px] font-bold text-brand-deep-ink underline-offset-2 hover:underline"
        >
          <QuestionCircleOutlined />
          {t("workingHours.guide.link")}
        </button>
      </p>
      <WorkingHoursGuideModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
